module.exports = __webpack_public_path__ + "static/select_your_preferences-ff61ced476f16df7d61621d3b9ffea54.jpg";